export const API_STATUS_CODES = {
  badRequest: 400,
  unauthorized: 401,
  ok: 200,
  clientError: 409,
  invalidCredentials: -100,
  resourceNotFound: -101,
};
